import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const customerBySalesTodo = createAsyncThunk('customerBySales', async ({ data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `tour-plan-by-sales`,
            params: {
                'userId': data?.sales_person,
                'tour_plan_type': data?.type,
                'day': data?.day,
                'date': data?.date,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const customerBySalesSlice = createSlice({
    name: 'customerBySales',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(customerBySalesTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(customerBySalesTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default customerBySalesSlice.reducer; 